export enum PrioritizeRequestStatus {
    None = 'None',
    InProgress = 'InProgress',
    Ready = 'Ready',
    Nudged = 'Nudged',
}
